import { html, LitElement } from "lit";
import { customElement } from "lit/decorators.js";

import styles from "./text-greek.css";

@customElement("bp-text-greek")
export class TextGreek extends LitElement {
  static styles = styles;

  render() {
    return html` <slot></slot> `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-text-greek": TextGreek;
  }
}
